<template>
    <div class="all">
        <van-nav-bar
                title="注册"
                left-text="返回"
                right-text=""
                left-arrow
                @click-left="$goBack()"
        />
        <div class="blank"></div>
        <div class="register">
            <van-row>
                <van-col span="2"><img :src="phone"></van-col>
                <van-col span="15">
                    <van-field v-model="form.contactPhone" placeholder="请输入您的手机号码"/>
                </van-col>
                <van-col span="7">
                    <van-button size="small" @click='sendCode()'
                                :disabled="timerCodeBtn.time > 0"
                                :plain="timerCodeBtn.time > 0"
                    >
                        {{timerText}}
                    </van-button>

                </van-col>
            </van-row>
            <van-row>
                <van-col span="2"><img :src="photo"></van-col>
                <van-col span="16">
                    <van-field v-model="form.smsCode" placeholder="请输入验证码"/>
                </van-col>
            </van-row>
            <van-row>
                <van-col span="2"><img :src="suo"></van-col>
                <van-col span="22">
                    <van-field v-model="form.password" type="passWord" placeholder="账号密码为6-18的数字和英文"/>
                </van-col>
            </van-row>
            <van-row>
                <van-col span="2"><img :src="suo"></van-col>
                <van-col span="22">
                    <van-field v-model="nextPassword" type="passWord" placeholder="请确认账号密码"/>
                </van-col>
            </van-row>
            <van-row>
                <van-col span="2"><img :src="yaoqingma"></van-col>
                <van-col span="22">
                    <van-field v-model="form.inviteCode" placeholder="向你的邀请者索取邀请码" :readonly="readonly"/>
                </van-col>
            </van-row>
            <van-row>
                <van-col span="2"><img :src="person"></van-col>
                <van-col span="22">
                    <van-field v-model="form.traderName" placeholder="请填写真实姓名"/>
                </van-col>
            </van-row>
            <van-row>
                <van-col span="2"><img :src="shop"></van-col>
                <van-col span="22">
                    <van-field v-model="form.storeName" placeholder="请填写网点/门店名称(非必填)"/>
                </van-col>
            </van-row>
            <van-row>
                <van-col span="2">
                    <img :src="address">
                </van-col>
                <van-col span="22">
                    <van-field
                            v-model="form.province+form.city+form.area"
                            @click="addressClick()"
                            placeholder="请选择省市区(非必填)"
                    />
                </van-col>
            </van-row>
            <van-row>
                <van-field v-model="form.contactAddress" placeholder="详细xx路xx号(非必填)"/>
            </van-row>
        </div>
        <div class="bottom">
            <van-button round size="large" @click="register()" :loading="submitLoading">立即注册</van-button>
            <p>点击"立即注册",表示您已阅读并同意 <router-link to="/agreement"><span>客户服务协议声明</span></router-link></p>
        </div>

        <van-popup v-model="show" position="bottom">
            <van-area :area-list="areaList" value="110101" title="地 址" @cancel="cancel" @confirm="confirm" style="width: 95%; margin:0 auto"/>
        </van-popup>
    </div>
</template>

<script>
    import person1 from '@/assets/images/person1.png'
    import yaoqingma from '@/assets/images/yaoqingma.png'
    import suo from '@/assets/images/suo.png'
    import shop from '@/assets/images/shop.png'
    import phone from '@/assets/images/phone.png'
    import photo from '@/assets/images/photo.png'
    import address from '@/assets/images/address.png'
    import constantAPI from '@/api/constant'

    export default {
        data() {
            return {
                person: person1,
                yaoqingma: yaoqingma,
                suo: suo,
                shop: shop,
                phone: phone,
                photo: photo,
                address: address,
                itemHeight: 40,
                show: false,
                readonly: false,
                selectArea: [],
                areaList: {},
                form: {
                    inviteCode: '',//邀请码
                    password: '',
                    traderName: '',//真实姓名
                    storeName: '',//门店名称
                    province: '',//省
                    city: '',//市
                    area: '',//区
                    contactPhone: '',//联系手机
                    contactAddress: '',//地址
                    smsCode: '',
                },
                nextPassword: '',//再次确认密码
                submitLoading:false,
                timerCodeBtn: {
                    time: 0,
                    disabled: false
                }
            }
        },
        computed: {
            timerText: function () {
                return this.timerCodeBtn.time > 0 ? this.timerCodeBtn.time + 'S再获取' : '发送验证码';
            }
        },
        watch: {},
        created() {
            this.getArea();
            this.getParams();
        },
        methods: {
            getParams() {
                var routerParams = this.$route.query.inviteCode
                this.form.inviteCode = routerParams
                if (this.form.inviteCode) {
                    this.readonly = true
                }
            },
            getArea() {
                constantAPI.areaList().then((result) => {
                    this.areaList = result.data
                })
            },
            addressClick() {
                this.show = true
                this.overlay = false
            },
            cancel() {
                this.show = false
            },
            confirm(e) {
                this.selectArea = e
                if (this.selectArea[0].name == this.selectArea[1].name) {
                    this.form.city = this.selectArea[1].name;
                    this.form.area = this.selectArea[2].name;
                } else {
                    this.form.province = this.selectArea[0].name;
                    this.form.city = this.selectArea[1].name;
                    this.form.area = this.selectArea[2].name;
                }
                this.show = false
            },
            timer: function () {
                if (this.timerCodeBtn.time > 0) {
                    this.timerCodeBtn.time--
                    setTimeout(this.timer, 1000)
                }
            },
            sendCode() {
                if (!this.$myUtil.mobile(this.form.contactPhone)) {
                    this.$toast("手机号不正确")
                    return
                }
                this.submitLoading=false
                this.$http({
                    url: '/code/send',
                    method: 'get',
                    params: {phone: this.form.contactPhone}
                }).then((result) => {
                    this.timerCodeBtn.time = 90
                    this.timer()
                }).catch((error) => {
                  this.submitLoading=true
                })
            },
            register() {
                if (this.nextPassword != this.form.password) {
                    this.$toast("两次密码不同！")
                    return
                }
                if (!this.$myUtil.isLegalPwd(this.form.password)) {
                    this.$toast("请输入6-25位数字、字符、字母最少两种组合密码")
                    return
                }
                this.$http({
                    url: '/user/register',
                    method: 'post',
                    data: this.form
                }).then((result) => {
                    let encodeUrlGo = encodeURIComponent(this.$route.query.go ? this.$route.query.go : '/main')
                    this.$toast.success('注册成功')
                    this.$router.push('/login?go=' + encodeUrlGo)
                }).catch((error) => {
                })


            }

        }
    }
</script>

<style lang="scss" scoped>

    .all {
        background-color: #FFF;
    }

    .blank {
        background-color: #bfbfbf;
    }

    .register {
        margin: 2rem;
        .van-row {
            line-height: 4rem;
            border-bottom: 1px solid #f2f2f2;
            .van-button {
                background-color: #ee9900;
                color: #FFFFFF;
            }
        }
        img {
            height: 1.5rem;
            width: 1.5rem;
        }
    }

    .bottom {
        margin: 2rem;
        .van-button {
            background-color: #ee9900;
            color: #fff;
        }
        p {
            text-align: center;
            font-size: 1rem;
            color: #bfbfbf;
            span {
                color: #ee9900;
            }
        }
    }

</style>
